/* dc-luxist: tiny controller loader, no inline JS */
window.DC = window.DC || {};
DC.controllers = DC.controllers || {};

DC.controllers['dc-section'] = (root) => {
  // hydrate on view (keeps theme fast)
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if (e.isIntersecting){ io.disconnect(); }
    });
  }, {rootMargin:'200px'});
  io.observe(root);
};

(function init(){
  const run=()=>document.querySelectorAll('[data-controller="dc-section"]').forEach(el=>{
    if(!el.__dcInit){ el.__dcInit=true; DC.controllers['dc-section']?.(el); }
  });
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',run):run();
})();
